// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f491f72","453":"887d0be5","455":"096a6026"}[chunkId] + ".chunk.js";
};